import { VISIBLE_MEDIA_GENERATION_JOB_STATUSES, isActiveMediaGenerationJob } from 'modules/manager/domain/media-generation-job';
import { useMediaGenerationJobsQuery } from 'modules/manager/store/media-generation-jobs-api';
import { useState } from 'react';

/**
 * Сколько последних картинок показывает вкладка. Полная история — в «Очереди медиа»,
 * но она только для супер-админа, а здесь — то, что админ турнира только что сгенерировал.
 */
export const CHAMPIONSHIP_MEDIA_JOBS_PER_PAGE = 20;

/** Пока картинка рендерится, админ ждёт её на этом же экране — опрашиваем чаще, чем очередь. */
export const CHAMPIONSHIP_MEDIA_JOBS_POLL_MS = 5000;

/**
 * Картинки соревнования: задачи генерации с `championshipId`. Один и тот же запрос читают счётчик
 * на подвкладке и сам список — RTK Query отдаёт им одну подписку, а опрос включается, пока хоть
 * одна задача в `PENDING` / `RENDERING`.
 *
 * @param organizerId организация соревнования — `tournamentId` бэкенда.
 */
export function useChampionshipMediaJobs(championshipId: number, organizerId: number) {
  const [hasActive, setHasActive] = useState(false);
  const query = useMediaGenerationJobsQuery(
    {
      tournamentId: organizerId,
      championshipId,
      // Скрытые («Скрыть» = отклонить) не показываем и не считаем в счётчике подвкладки.
      statuses: VISIBLE_MEDIA_GENERATION_JOB_STATUSES,
      perPage: CHAMPIONSHIP_MEDIA_JOBS_PER_PAGE,
    },
    { skip: !organizerId, pollingInterval: hasActive ? CHAMPIONSHIP_MEDIA_JOBS_POLL_MS : 0 },
  );

  // Интервал опроса зависит от ответа того же запроса: состояние обновляется при рендере,
  // а не в эффекте, чтобы опрос включился в том же проходе, где пришла задача в работе.
  const nextHasActive = Boolean(query.data?.items.some(isActiveMediaGenerationJob));
  if (nextHasActive !== hasActive) {
    setHasActive(nextHasActive);
  }

  return query;
}
